const STORAGE_KEY = 'dulceReviewerId';

export const getOrCreateReviewerId = () => {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
        id = `user_${Math.random().toString(36).slice(2, 11)}`;
        localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
};
